import type { Ranges } from 'api/System/types'
import config from 'config'
import { selectSkipRefetchOwners } from 'data/selectors'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import type { RequestDate } from 'types/UI'
import { fetchAction } from 'utils'

import * as constants from './constants'

interface FetchAction {
  dateCurrent: RequestDate
  dateCompared?: RequestDate | null
  range: Ranges
}

const fetchOwners = createLogic<State, FetchAction>({
  type: constants.FETCH_OWNERS,
  latest: true,

  async process({ action, getState }, dispatch, done) {
    try {
      const anyAction = action as any
      const state = getState()
      const baseRequestParams = dateMenuSelectors.baseRequestParams(state, action as any)
      const skipRefetch = selectSkipRefetchOwners(state)

      if (skipRefetch) {
        dispatch({
          type: constants.FETCH_OWNERS_DONE,
          payload: action.payload,
        })
      } else {
        const response = await fetchAction(config.api.owners, baseRequestParams)

        dispatch({
          type: constants.FETCH_OWNERS_SUCCESS,
          payload: {
            ...anyAction.payload,
            data: response.data,
          },
        })
      }
    } catch (error) {
      dispatch({
        ...action,
        type: constants.FETCH_OWNERS_ERROR,
      })
    }
    done()
  },
})

export default [fetchOwners]
